import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  model,
  OnInit,
  Output,
  signal,
  effect,
  inject
} from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { interval, Subscription } from 'rxjs';
import { RequestService } from '../request-service/request.service';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { DisplayFileComponent } from "../display-file/display-file.component";
import { TranslatePipe } from '@ngx-translate/core';
import { FilesMappingService } from "../../core/services/files-mapping/files-mapping.service";
import { IconChevronComponent } from '../../shared/components/icon-chevron/icon-chevron.component';
import { IconEyeComponent } from '../../shared/components/icon-eye/icon-eye.component';
import { StatusBadgeComponent } from '../../shared/components/status-badge/status-badge.component';

@Component({
  selector: 'app-batch-line',
  standalone: true,
  imports: [
    DisplayFileComponent,
    TranslatePipe,
    CommonModule,
    IconChevronComponent,
    IconEyeComponent,
    StatusBadgeComponent
  ],
  templateUrl: './batch-line.component.html',
  styleUrl: './batch-line.component.css'
})
export class BatchLineComponent implements OnInit {

  filesMapping = inject(FilesMappingService);

  @Input() reconciliation: any;
  @Input() batchId: number;
  @Input() isReconciling: boolean;
  @Input() isBankReconciliation: boolean;
  selectedCustomer = model<any>(null);
  @Output() newReconciliation = new EventEmitter<any>();
  @Output() relauchReconciliation = new EventEmitter<any>();
  @Output() reconciliationStatusChanged = new EventEmitter<any>();
  control = model<number>(0);
  fileName: string | undefined;
  loading: boolean = false;
  uploadProgress: number = 0;
  error: string | null;
  private subscription: Subscription;
  private apiUrl: string = environment.apiUrl
  showFiles = signal<boolean>(false);
  endPoint: string;

  totalFiles() {
    if (this.reconciliation.source1.sourceType.type === 'CLASSIC')
      return this.reconciliation.source1?.sourcePaths?.length;
    else return this.reconciliation.children.map((current: any) => current.externalSelectedFile.length).reduce((a: number, b: number) => a + b, 0);
  };

  constructor(
    private http: HttpClient,
    private requestService: RequestService,
    private router: Router,
  ) {
    effect(() => { });
  }

  ngOnInit(): void {
    if (this.isBankReconciliation) {
      this.endPoint = 'bank-multiple';
    }
    else this.endPoint = 'multiple';
    if (this.reconciliation.status && !(this.reconciliation.status === 'DONE' || this.reconciliation.status === 'RECONCILIATION_ERROR' || this.reconciliation.status === "TRANSFORMATION_ERROR")) {
      this.subscription = interval(5000).subscribe(() => {
        this.checkStatus();
      });
    }
    const isClassicSource = this.reconciliation?.source1?.sourceType?.type === 'CLASSIC' || this.reconciliation?.source1?.type === 'CLASSIC';
    if ((this.reconciliation?.externalSelectedFile?.length > 0 && isClassicSource) || (this.reconciliation?.children?.length > 0 && this.reconciliation?.source1?.type === 'VIRTUAL')) {
      if (this.reconciliation?.source2) {
        this.relaunchReconciliation(this.reconciliation.externalSelectedFile);
      } else {
        this.lauchReconciliation(this.reconciliation.externalSelectedFile);
      }
    }
  }

  onShowFiles() {
    this.showFiles.update(current => current = !current);
  }

  lauchReconciliation(files: File[]) {
    if (files?.length > 0) {
      const formData = new FormData();
      this.error = null;
      if (this.reconciliation.source1.type === 'VIRTUAL') {
        const sourceTypeCodes: string[] = [];

        this.reconciliation.source1?.sourceTypes.forEach((source: any) => {
          const res = this.filesMapping.filterAndMapFiles(source, files, this.batchId);
          if (res.files.length > 0) {
            res.files.forEach(() => {
              sourceTypeCodes.push(source.code);
            });
          }
        });

        Array.from(files).forEach(file => {
          formData.append('sources', file);
        });

        formData.append('bundle', JSON.stringify({
          name: "Rec_" + this.reconciliation.source1.name,
          typeSource2: [...sourceTypeCodes, this.reconciliation.source1.code]
        }));

        this.launchBundleReconciliation(formData);
      }
      else {
        for (let file of Array.from(files)) {
          if (file && this.checkNewReconciliation(file)) {
            formData.append('sources', file);
            formData.append('sourceTypeCode', this.reconciliation.source1.code);
          }
        }
        this.launchClassicReconciliation(formData);
      }
    }
  }

  private launchBundleReconciliation(formData: FormData) {
    this.loading = true;
    this.uploadProgress = 0;
    let url = '';
    if (this.selectedCustomer()) {
      url = `${this.apiUrl}/reconciliations/${this.batchId}/bundle/customer/${this.selectedCustomer().id}`;
    } else {
      url = `${this.apiUrl}/reconciliations/${this.batchId}/bundle`;
    }
    this.http.post(url, formData, { reportProgress: true, observe: 'events' })
      .subscribe(
        (event: HttpEvent<any>) => {
          if (event.type === HttpEventType.UploadProgress) {
            this.uploadProgress = Math.round((event.loaded / (event.total || 1)) * 100);
          } else if (event.type === HttpEventType.Response) {
            this.loading = false;
            if (this.reconciliation.children) {
              this.reconciliation = { children: this.reconciliation.children, ...event.body };
            } else {
              this.reconciliation = event.body;
            }
            this.newReconciliation.emit(event.body);
            this.subscription = interval(5000).subscribe(() => {
              this.checkStatus();
            });
          }
        },
        (err: any) => {
          this.loading = false;
        }
      );
  }

  private launchClassicReconciliation(formData: FormData) {
    this.loading = true;
    this.uploadProgress = 0;
    let url = '';
    if (this.selectedCustomer()) {
      url = `${this.apiUrl}/reconciliation-batches/${this.batchId}/reconciliations/customer/${this.selectedCustomer().id}/test/${this.endPoint}`;
    } else {
      url = `${this.apiUrl}/reconciliation-batches/${this.batchId}/reconciliations/${this.endPoint}`;
    }
    this.http.post(url, formData, { reportProgress: true, observe: 'events' })
      .subscribe(
        (event: HttpEvent<any>) => {
          if (event.type === HttpEventType.UploadProgress) {
            this.uploadProgress = Math.round((event.loaded / (event.total || 1)) * 100);
          } else if (event.type === HttpEventType.Response) {
            this.loading = false;
            if (this.reconciliation.children) {
              this.reconciliation = { children: this.reconciliation.children, ...event.body };
            } else {
              this.reconciliation = event.body;
            }
            this.newReconciliation.emit(event.body);
            this.subscription = interval(5000).subscribe(() => {
              this.checkStatus();
            });
          }
        },
        (err: any) => {
          this.loading = false;
        }
      );
  }

  checkNewReconciliation(file: File) {
    if (this.reconciliation.name && this.reconciliation.source1.path.includes(file?.name)) {
      return false;
    }
    return true;
  }

  downloadSource(sourceName: string) {
    this.http
      .get(
        this.apiUrl +
        `/reconciliations/download?file=${sourceName}`,
        { responseType: 'blob' }
      )
      .subscribe((data: Blob) => {
        const blob = new Blob([data], { type: 'application/zip' });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');

        link.href = url;
        link.download = sourceName;
        link.click();

        window.URL.revokeObjectURL(url);
      });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  checkStatus(): void {
    this.requestService.getRequestStatusById(this.reconciliation.id).subscribe((res: any) => {
      this.reconciliation.status = res.status;
      this.reconciliationStatusChanged.emit(this.reconciliation);
      if (res.status === 'DONE' || res.status === 'RECONCILIATION_ERROR' || res.status === "TRANSFORMATION_ERROR") {
        this.subscription.unsubscribe();
      }
    });
  }

  showReconciliation() {
    this.router.navigate([`/backoffice/requestdetail/${this.reconciliation.id}`], { queryParamsHandling: 'merge', queryParams: { page: null } });
  }

  relaunchReconciliation(files: File[]) {
    const formData = new FormData();
    for (let file of files) {
      formData.append('typeSource', this.reconciliation.source1.code);
      formData.append('sources', file);
    }
    this.loading = true;
    this.http
      .put(`${this.apiUrl}/reconciliations/${this.reconciliation.id}/replay-multiple`, formData, {
        reportProgress: true,
        observe: 'events',
      })
      .subscribe(
        (event: HttpEvent<any>) => {
          if (event.type === HttpEventType.UploadProgress) {
            this.uploadProgress = Math.round((event.loaded / (event.total || 1)) * 100);
          } else if (event.type === HttpEventType.Response) {
            this.loading = false;
            if (this.reconciliation.children) {
              this.reconciliation = { children: this.reconciliation.children, ...event.body };
            } else {
              this.reconciliation = event.body;
            }
            this.relauchReconciliation.emit(event.body);
            this.subscription = interval(5000).subscribe(() => {
              this.checkStatus();
            });
          }
        },
        (err: any) => {
          this.loading = false;
        }
      );
  }

  onFileChange(event: any): void {
    const files = event.target.files;
    if (files && files.length > 0) {
      const selectedFiles = Array.from(files) as File[];
      if (this.reconciliation?.source2) {
        this.error = null;
        this.relaunchReconciliation(selectedFiles);
      } else {
        if (this.reconciliation?.source1?.type === 'VIRTUAL') {
          this.reconciliation.children.forEach((child: any) => {
            const res = this.filesMapping.filterAndMapFiles(child.source1, selectedFiles, this.batchId);
            if (res.files.length > 0)
              child.externalSelectedFile = res.files;
          });
        }
        this.lauchReconciliation(selectedFiles);
      }
    }
  }

  getSourceFormat() {
    const sourceFormat = this.reconciliation.source1?.sourceFormat || this.reconciliation.source1?.sourceType?.sourceFormat;
    return '.' + sourceFormat?.toLowerCase();
  }

}
